import {
  printNoDataChart,
  printDataChart,
  initChart,
  configureDataGaugeMonthCommon,
} from 'vlcishared';
import { DEFAULT_LANGUAGE } from '../common-language';
import { TEXTS_GAUGE_MONTH } from './texts';

import { OPTIONS_GAUGE_MONTH } from './options-charts';

export function initGaugeMonth(gaugeMonthConfig, datos, mesSeleccionado) {
  const datosArray = datos.resultset;

  if (
    datosArray.length === 0 ||
    mesSeleccionado < 0 ||
    mesSeleccionado >= datosArray.length
  ) {
    printNoDataChart(
      `#${gaugeMonthConfig.idChart}`,
      `#${gaugeMonthConfig.idNoData}`,
    );
  } else {
    printDataChart(
      `#${gaugeMonthConfig.idNoData}`,
      `#${gaugeMonthConfig.idChart}`,
    );

    const datoMes = datosArray[mesSeleccionado];

    const objColData = {
      type: 0,
      time: 1,
      data: 2,
    };

    const [maxValue, seriesDetailFormatter, gaugeDataMonth] =
      configureDataGaugeMonthCommon(
        gaugeMonthConfig.idChart,
        [datoMes],
        objColData,
        0,
      );

    const options = JSON.parse(JSON.stringify(OPTIONS_GAUGE_MONTH));
    options.title.text = gaugeMonthConfig.chartName;
    options.series.max = maxValue;
    options.series.detail.formatter = seriesDetailFormatter;
    options.series.data = gaugeDataMonth;

    initChart(gaugeMonthConfig.idChart, options);
  }
}

export function echartUsuarisTotalsGaugeMonth(vis, datos) {
  const gaugeMonthConfig = {
    idChart: 'chartUsuarisTotalsGaugeMonth',
    idNoData: 'no_dataUsuarisTotalsGaugeMonth',
    chartName: `${TEXTS_GAUGE_MONTH[DEFAULT_LANGUAGE].get(
      'chartUsuarisTotalsGaugeMonth',
    )}`,
  };

  const gaugeLastMonthConfig = {
    idChart: 'chartUsuarisTotalsGaugeLastMonth',
    idNoData: 'no_dataUsuarisTotalsGaugeLastMonth',
    chartName: `${TEXTS_GAUGE_MONTH[DEFAULT_LANGUAGE].get(
      'chartUsuarisTotalsGaugeLastMonth',
    )}`,
  };

  const MES_ACTUAL = 0;
  const MES_ANTERIOR = 1;

  initGaugeMonth(gaugeMonthConfig, datos, MES_ACTUAL); 
  initGaugeMonth(gaugeLastMonthConfig, datos, MES_ANTERIOR); 
}
